import { Action } from '@ngrx/store';
import { Tracking } from '../../_models/tracking';
import { User } from '../../_models/user';

export enum TrackingActitonTypes {

  ClearTracking = '[Tracking] Clear',
  InicializeTracking = '[Tracking] Inicialize',

  GetCurrentTracking = '[Tracking] Get Current',
	SetCurrentTracking = '[Tracking] Set Current',
	SetCurrentTrackingId = '[Tracking] Set Current Id',

	SetFilterFields = '[Tracking] Set Filter Fields',

	LoadTrackings = '[Tracking] Get List',
	LoadTrackingsSuccess = '[Tracking] Load Success',
  LoadTrackingsFail = '[Tracking] Load Fail',

  UpdateTracking = '[Tracking] Update',
  UpdateTrackingSuccess = '[Tracking] Update Success',
	UpdateTrackingFail = '[Tracking] Update Fail',

	CreateTracking = '[Tracking] Create',
  CreateTrackingSuccess = '[Tracking] Create Success',
	CreateTrackingFail = '[Tracking] Create Fail',

	DeleteTracking = '[Tracking] Delete',
  DeleteTrackingSuccess = '[Tracking] Delete Success',
	DeleteTrackingFail = '[Tracking] Delete Fail',

	AddTracking = '[Tracking] Add Tracking',

	LoadUsers = '[Tracking] Get Users',
	LoadUsersSuccess = '[Tracking] Load Users Success',
  LoadUsersFail = '[Tracking] Load Users Fail'
}

export class ClearTracking implements Action {
	readonly type = TrackingActitonTypes.ClearTracking;
}

export class InicializeTracking implements Action {
	readonly type = TrackingActitonTypes.InicializeTracking;
}

export class GetCurrentTracking implements Action {
	readonly type = TrackingActitonTypes.GetCurrentTracking;
}

export class SetCurrentTracking implements Action {
	readonly type = TrackingActitonTypes.SetCurrentTracking;

	constructor(public payload: Tracking) {}
}

export class SetCurrentTrackingId implements Action {
	readonly type = TrackingActitonTypes.SetCurrentTrackingId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = TrackingActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadTrackings implements Action {
	readonly type = TrackingActitonTypes.LoadTrackings;

	constructor(public payload: any) {}
	// constructor(public payload: {
    //   finished: boolean,
    //   searchDesc: string,
    //   searchName: string
    // }) {}
}

export class LoadTrackingsSuccess implements Action {
	readonly type = TrackingActitonTypes.LoadTrackingsSuccess;

	constructor(public payload: Tracking[]) {}
}

export class LoadTrackingsFail implements Action {
	readonly type = TrackingActitonTypes.LoadTrackingsFail;

	constructor(public payload: string) {}
}

export class UpdateTracking implements Action {
	readonly type = TrackingActitonTypes.UpdateTracking;

	constructor(public payload: Tracking) {}
}

export class UpdateTrackingSuccess implements Action {
	readonly type = TrackingActitonTypes.UpdateTrackingSuccess;

	constructor(public payload: Tracking) {}
}

export class UpdateTrackingFail implements Action {
	readonly type = TrackingActitonTypes.UpdateTrackingFail;

	constructor(public payload: string) {}
}

export class DeleteTracking implements Action {
	readonly type = TrackingActitonTypes.DeleteTracking;

	constructor(public payload: Tracking) {}
}

export class DeleteTrackingSuccess implements Action {
	readonly type = TrackingActitonTypes.DeleteTrackingSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteTrackingFail implements Action {
	readonly type = TrackingActitonTypes.DeleteTrackingFail;

	constructor(public payload: string) {}
}

export class CreateTracking implements Action {
	readonly type = TrackingActitonTypes.CreateTracking;

	constructor(public payload: Tracking) {}
}

export class CreateTrackingSuccess implements Action {
	readonly type = TrackingActitonTypes.CreateTrackingSuccess;

	constructor(public payload: Tracking) {}
}

export class CreateTrackingFail implements Action {
	readonly type = TrackingActitonTypes.CreateTrackingFail;

	constructor(public payload: string) {}
}

export class AddTracking implements Action {
	readonly type = TrackingActitonTypes.AddTracking;

	constructor(public payload: Tracking) {}
}

// ------- AGENTES COMERCIALES --------
export class LoadUsers implements Action {
	readonly type = TrackingActitonTypes.LoadUsers;
}

export class LoadUsersSuccess implements Action {
	readonly type = TrackingActitonTypes.LoadUsersSuccess;

	constructor(public payload: User[]) {}
}

export class LoadUsersFail implements Action {
	readonly type = TrackingActitonTypes.LoadUsersFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type TrackingActions = ClearTracking
| InicializeTracking
| GetCurrentTracking
| SetCurrentTracking
| SetCurrentTrackingId
| SetFilterFields
| LoadTrackings
| LoadTrackingsSuccess
| LoadTrackingsFail
| UpdateTracking
| UpdateTrackingSuccess
| UpdateTrackingFail
| CreateTracking
| CreateTrackingSuccess
| CreateTrackingFail
| DeleteTracking
| DeleteTrackingSuccess
| DeleteTrackingFail
| AddTracking
| LoadUsers
| LoadUsersSuccess
| LoadUsersFail;
